export var PolicyStatus;
(function (PolicyStatus) {
    PolicyStatus["Active"] = "active";
    PolicyStatus["Prospecting"] = "prospecting";
    PolicyStatus["Inactive"] = "inactive";
    PolicyStatus["Archived"] = "archived";
})(PolicyStatus || (PolicyStatus = {}));
